import React, { createContext } from 'react';
import { UseQueryResult } from 'react-query';

//import { IPeopleFilterType } from 'store/reducers/people/people-reducer';

export interface ResourcesNLPSearchInfo {
  searchValue?: string;
  currentFilter?: IPeopleFilterType;
  searchFocused?: boolean;
  nlpSearchQuery?: UseQueryResult<any, Error>;
  searchInputRef?: React.RefObject<HTMLInputElement>;
  sendSearch?: (search?: string) => void;
  setSearchValue?: React.Dispatch<React.SetStateAction<string>>;
  //  setCurrentFilter?: React.Dispatch<React.SetStateAction<IPeopleFilterType>>;
  setSearchFocused?: React.Dispatch<React.SetStateAction<boolean>>;
  showHistory?: boolean;
  setShowHistory?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ResourcesNLPSearchContext = createContext<ResourcesNLPSearchInfo>({
  searchValue: '',
  currentFilter: null,
  searchFocused: false,
  nlpSearchQuery: null,
  searchInputRef: null,
  sendSearch: () => {},
  setSearchValue: () => {},
  //  setCurrentFilter: () => {},
  setSearchFocused: () => {},
  showHistory: false,
  setShowHistory: () => {},
});
